(function(){'use strict';

var FREE_SHIPPING_THRESHOLD_CLP = 25000;
var NEWSLETTER_STORAGE_KEY = 'protocol_newsletter_seen_v1';
var NEWSLETTER_DAYS = 30;
var NEWSLETTER_SCROLL_PCT = 50;

function initVariantSelector(){
  var heroForm = document.querySelector('[data-protocol-hero-form]');
  if (!heroForm) return;
  var variantInput = heroForm.querySelector('[data-protocol-variant-input]');
  var buyPriceEl = heroForm.querySelector('[data-protocol-buy-price]');
  var buyCta = heroForm.querySelector('[data-protocol-buy-cta]');
  var variantBtns = heroForm.querySelectorAll('[data-protocol-variant]');
  var bundleBtn = heroForm.querySelector('[data-protocol-bundle]');
  function setBuyText(prefix, formattedPrice){
    if(!buyCta) return;
    var nodes = buyCta.childNodes;
    for (var i=0; i<nodes.length; i++){
      if (nodes[i].nodeType===Node.TEXT_NODE && nodes[i].textContent.trim().length>0){
        nodes[i].textContent = prefix + ' · '; break;
      }
    }
    if (buyPriceEl) buyPriceEl.textContent = formattedPrice;
  }
  function selectVariant(target){
    variantBtns.forEach(function(b){ b.setAttribute('aria-pressed', b===target?'true':'false'); });
    if (bundleBtn) bundleBtn.setAttribute('aria-pressed','false');
    var vid = target.getAttribute('data-variant-id');
    var price = target.getAttribute('data-variant-price-formatted');
    if (variantInput && vid) variantInput.value = vid;
    setBuyText('Agregar al carrito', price);
    syncStickyCart(vid, price);
  }
  function selectBundle(){
    variantBtns.forEach(function(b){ b.setAttribute('aria-pressed','false'); });
    bundleBtn.setAttribute('aria-pressed','true');
    var bvid = bundleBtn.getAttribute('data-bundle-variant-id');
    var bprice = bundleBtn.getAttribute('data-bundle-price-formatted');
    if (variantInput && bvid) variantInput.value = bvid;
    setBuyText('Agregar pack', bprice);
  }
  variantBtns.forEach(function(b){ b.addEventListener('click', function(){ selectVariant(b); }); });
  if (bundleBtn) bundleBtn.addEventListener('click', selectBundle);
}

function initGallery(){
  var media = document.getElementById('protocol-hero-media');
  if (!media) return;
  var images = media.querySelectorAll('[data-protocol-gallery-image]');
  var thumbs = media.querySelectorAll('[data-protocol-gallery-thumb]');
  if (thumbs.length===0) return;
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var idx = thumb.getAttribute('data-protocol-gallery-thumb');
      thumbs.forEach(function(t){ t.setAttribute('aria-pressed', t===thumb?'true':'false'); });
      images.forEach(function(img){
        img.style.display = img.getAttribute('data-protocol-gallery-image')===idx ? 'block' : 'none';
      });
    });
  });
}

function initReveal(){
  var els = document.querySelectorAll('.protocol-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(e){ io.observe(e); });
}

function initStickyCart(){
  var sticky = document.querySelector('[data-protocol-sticky-cart]');
  if (!sticky) return;
  var hero = document.querySelector('.protocol-hero');
  var threshold = hero ? hero.offsetHeight*0.6 : 600;
  var ticking = false;
  function onScroll(){
    var y = window.scrollY || window.pageYOffset;
    if (!ticking){
      window.requestAnimationFrame(function(){ sticky.classList.toggle('is-visible', y > threshold); ticking = false; });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
}
function syncStickyCart(variantId, formattedPrice){
  var input = document.querySelector('[data-protocol-sticky-variant-input]');
  var price = document.querySelector('[data-protocol-sticky-price]');
  if (!input || !price) return;
  var heroVars = document.querySelectorAll('[data-protocol-variant]');
  var match = false;
  heroVars.forEach(function(b){ if (b.getAttribute('data-variant-id')===variantId) match = true; });
  if (match){ input.value = variantId; price.textContent = formattedPrice; }
}

function formatMoneyCLP(cents){ return '$' + Math.round(cents/100).toLocaleString('es-CL'); }

function openDrawer(){
  var d = document.getElementById('protocol-cart-drawer');
  var o = document.getElementById('protocol-cart-overlay');
  if (!d) return;
  d.classList.add('is-open');
  if (o) o.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
}
function closeDrawer(){
  var d = document.getElementById('protocol-cart-drawer');
  var o = document.getElementById('protocol-cart-overlay');
  if (!d) return;
  d.classList.remove('is-open');
  if (o) o.classList.remove('is-visible');
  document.body.style.overflow = '';
}

function renderShippingBar(totalCents){
  var bars = document.querySelectorAll('[data-protocol-shipping-bar]');
  if (!bars.length) return;
  var totalCLP = totalCents / 100;
  bars.forEach(function(bar){
    var fill = bar.querySelector('[data-protocol-shipping-fill]');
    var msg = bar.querySelector('[data-protocol-shipping-msg]');
    var pct = Math.min(100, (totalCLP / FREE_SHIPPING_THRESHOLD_CLP) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg){
      if (totalCLP >= FREE_SHIPPING_THRESHOLD_CLP){
        msg.innerHTML = '✓ ¡Tienes envío gratis!';
        bar.classList.add('is-complete');
      } else {
        var faltaCents = (FREE_SHIPPING_THRESHOLD_CLP * 100) - totalCents;
        msg.innerHTML = 'Te faltan <strong>' + formatMoneyCLP(faltaCents) + '</strong> para envío gratis';
        bar.classList.remove('is-complete');
      }
    }
  });
}

function computeStainQty(cart){
  var n = 0;
  cart.items.forEach(function(item){ if (item.handle === 'protocol-stain') n += item.quantity; });
  return n;
}
function renderVolumeMsg(cart){
  /* Promo -50% llevando 3+ retirada (jun 2026). Mantener no-op por compatibilidad. */
  return;
}

function renderCart(cart){
  var itemsEl = document.querySelector('[data-protocol-cart-items]');
  var emptyEl = document.querySelector('[data-protocol-cart-empty]');
  var subtotalEl = document.querySelector('[data-protocol-cart-subtotal]');
  var countEl = document.querySelector('[data-protocol-cart-count]');
  var footerEl = document.querySelector('[data-protocol-cart-footer]');
  if (countEl) countEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoneyCLP(cart.total_price);
  renderShippingBar(cart.total_price);
  renderVolumeMsg(cart);
  if (!cart.items.length){
    if (itemsEl) itemsEl.innerHTML = '';
    if (emptyEl) emptyEl.style.display = 'block';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }
  if (emptyEl) emptyEl.style.display = 'none';
  if (footerEl) footerEl.style.display = 'block';
  if (itemsEl){
    var html = '';
    cart.items.forEach(function(item){
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
      var variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      html += '<div class="protocol-cart-item" data-key="' + item.key + '">';
      html += '<div class="protocol-cart-item__img">';
      if (img) html += '<img src="' + img + '&width=200" alt="">';
      html += '</div><div class="protocol-cart-item__info">';
      html += '<div class="protocol-cart-item__title">' + item.product_title + '</div>';
      if (variantLabel) html += '<div class="protocol-cart-item__variant">' + variantLabel + '</div>';
      html += '<div class="protocol-cart-item__price">' + formatMoneyCLP(item.final_line_price) + '</div>';
      html += '<div class="protocol-cart-item__qty">';
      html += '<button type="button" data-protocol-qty="dec" data-key="' + item.key + '" aria-label="Restar">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button type="button" data-protocol-qty="inc" data-key="' + item.key + '" aria-label="Sumar">+</button>';
      html += '<button type="button" class="protocol-cart-item__remove" data-protocol-qty="rm" data-key="' + item.key + '">Quitar</button>';
      html += '</div></div></div>';
    });
    itemsEl.innerHTML = html;
  }
}

function fetchCart(){
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); return cart; });
}

function addToCart(formData){
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: formData
  }).then(function(r){ if (!r.ok) return r.json().then(function(err){ throw err; }); return r.json(); });
}

function changeQty(key, qty){
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Accept':'application/json', 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); return cart; });
}

function initCartDrawer(){
  var drawer = document.getElementById('protocol-cart-drawer');
  if (!drawer) return;
  fetchCart();
  var closeBtns = drawer.querySelectorAll('[data-protocol-cart-close]');
  var overlay = document.getElementById('protocol-cart-overlay');
  closeBtns.forEach(function(b){ b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if (e.key==='Escape') closeDrawer(); });
  drawer.addEventListener('click', function(e){
    var btn = e.target.closest('[data-protocol-qty]');
    if (!btn) return;
    var action = btn.getAttribute('data-protocol-qty');
    var key = btn.getAttribute('data-key');
    if (!key) return;
    var qtyEl = drawer.querySelector('[data-key="' + key + '"] .protocol-cart-item__qty span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (action === 'inc') changeQty(key, current + 1);
    else if (action === 'dec') changeQty(key, Math.max(0, current - 1));
    else if (action === 'rm') changeQty(key, 0);
  });
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-protocol-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.innerHTML = 'Agregando...'; }
    var fd = new FormData(form);
    addToCart(fd).then(function(){ return fetchCart(); }).then(function(){ openDrawer(); })
      .catch(function(err){ console.error('Cart error', err); alert('No pudimos agregar al carrito.'); })
      .finally(function(){ if (btn){ btn.disabled = false; btn.innerHTML = orig; } });
  });
}

function initCartPage(){
  var page = document.querySelector('.protocol-cart-page');
  if (!page) return;
  page.addEventListener('click', function(e){
    var btn = e.target.closest('[data-protocol-page-qty]');
    if (!btn) return;
    var action = btn.getAttribute('data-protocol-page-qty');
    var key = btn.getAttribute('data-key');
    if (!key) return;
    if (action === 'rm'){
      e.preventDefault();
      changePageQty(key, 0);
      return;
    }
    var input = page.querySelector('input[data-key="' + key + '"]');
    var cur = input ? parseInt(input.value, 10) : 1;
    if (action === 'inc') changePageQty(key, cur + 1);
    else if (action === 'dec') changePageQty(key, Math.max(0, cur - 1));
  });
  page.addEventListener('change', function(e){
    if (e.target.matches && e.target.matches('input[name="updates[]"]')){
      var key = e.target.getAttribute('data-key');
      var qty = parseInt(e.target.value, 10) || 0;
      if (key) changePageQty(key, qty);
    }
  });
}

function changePageQty(key, qty){
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Accept':'application/json', 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r){ return r.json(); }).then(function(cart){
    if (qty === 0 || !cart.items.length){ window.location.reload(); return cart; }
    var item = null;
    for (var i=0; i<cart.items.length; i++){ if (cart.items[i].key === key){ item = cart.items[i]; break; } }
    var line = document.querySelector('.protocol-cart-line[data-line-key="' + key + '"]');
    if (item && line){
      var price = line.querySelector('.protocol-cart-line__price');
      var input = line.querySelector('input[data-key="' + key + '"]');
      if (price) price.textContent = formatMoneyCLP(item.final_line_price);
      if (input) input.value = item.quantity;
    }
    var subtotalEl = document.querySelector('[data-protocol-page-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoneyCLP(cart.total_price);
    renderShippingBar(cart.total_price);
    renderVolumeMsg(cart);
    return cart;
  });
}

// UGC inline video player — added to protocol.js
function initUgcVideos(){
  var cards = document.querySelectorAll('[data-protocol-video-card]');
  if (!cards.length) return;
  cards.forEach(function(card){
    var video = card.querySelector('video');
    var btn = card.querySelector('[data-protocol-video-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      video.controls = true;
      video.muted = false;
      var p = video.play();
      if (p && typeof p.then === 'function') p.catch(function(){});
      card.classList.add('is-playing');
    });
    video.addEventListener('click', function(){
      if (!card.classList.contains('is-playing')) return;
      if (video.paused) video.play(); else video.pause();
    });
  });
}

function initNewsletterPopup(){
  var popup = document.getElementById('protocol-newsletter-popup');
  if (!popup) return;

  function hasSeen(){
    try {
      var v = localStorage.getItem(NEWSLETTER_STORAGE_KEY);
      if (!v) return false;
      var when = parseInt(v, 10);
      if (!when) return false;
      var age = (Date.now() - when) / (1000 * 60 * 60 * 24);
      return age < NEWSLETTER_DAYS;
    } catch(e) { return false; }
  }
  function markSeen(){
    try { localStorage.setItem(NEWSLETTER_STORAGE_KEY, String(Date.now())); } catch(e) {}
  }
  function openPopup(){
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    markSeen();
  }
  function closePopup(){
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  popup.querySelectorAll('[data-protocol-newsletter-close]').forEach(function(b){
    b.addEventListener('click', closePopup);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  var form = popup.querySelector('[data-protocol-newsletter-form]');
  var intro = popup.querySelector('[data-protocol-newsletter-intro]');
  var success = popup.querySelector('[data-protocol-newsletter-success]');
  if (form && intro && success){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var origLabel = btn ? btn.textContent : '';
      if (btn){ btn.disabled = true; btn.textContent = 'Enviando...'; }
      var fd = new FormData(form);
      fetch(form.action, { method: 'POST', body: fd, mode: 'no-cors' })
        .then(function(){
          intro.hidden = true;
          success.hidden = false;
        })
        .catch(function(){
          intro.hidden = true;
          success.hidden = false;
        })
        .finally(function(){
          if (btn){ btn.disabled = false; btn.textContent = origLabel; }
        });
    });
  }

  var copyBtn = popup.querySelector('[data-protocol-newsletter-copy]');
  if (copyBtn){
    copyBtn.addEventListener('click', function(){
      var codeEl = popup.querySelector('.protocol-newsletter-popup__code');
      if (!codeEl) return;
      var code = codeEl.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(code).then(function(){
          copyBtn.textContent = '✓ Copiado';
          setTimeout(function(){ copyBtn.textContent = 'Copiar código'; }, 2000);
        });
      } else {
        try {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
          copyBtn.textContent = '✓ Copiado';
          setTimeout(function(){ copyBtn.textContent = 'Copiar código'; }, 2000);
        } catch(e) {}
      }
    });
  }

  if (hasSeen()) return;

  var triggered = false;
  function checkScroll(){
    if (triggered) return;
    var scrollY = window.scrollY || window.pageYOffset;
    var winH = window.innerHeight;
    var docH = document.documentElement.scrollHeight;
    if (docH <= winH) return;
    var pct = ((scrollY + winH) / docH) * 100;
    if (pct >= NEWSLETTER_SCROLL_PCT){
      triggered = true;
      openPopup();
      window.removeEventListener('scroll', checkScroll);
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
}

function init(){
  initVariantSelector();
  initGallery();
  initReveal();
  initStickyCart();
  initCartDrawer();
  initCartPage();
  initUgcVideos();
  initNewsletterPopup();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
